/* tslint:disable */
import {
  Partner,
  Product,
  Company,
  StockMove,
  StockLocation,
  StockWarehouseLocation,
  Users
} from '../index';

declare var Object: any;
export interface StockPickingInterface {
  "id"?: number;
  "name"?: string;
  "active"?: boolean;
  "date_provided_invoice"?: Date;
  "weight"?: number;
  "weight_net"?: number;
  "gallery_id"?: number;
  "state"?: string;
  "supplier_picking"?: string;
  "order_supplier_ref"?: string;
  "related_claim_counter"?: number;
  "related_images_counter"?: number;
  "real_date"?: Date;
  "req_charge_date"?: Date;
  "note"?: string;
  "quality_state"?: string;
  "operator_id"?: number;
  "di_delivered"?: boolean;
  "quality_control"?: boolean;
  "partner_id"?: number;
  "product_move"?: number;
  "company_id"?: number;
  "move_lines"?: Array<any>;
  "location_id"?: number;
  "warehouse_location_id"?: number;
  partner?: Partner;
  product?: Product;
  company?: Company;
  lines?: StockMove[];
  location?: StockLocation;
  warehouse_location?: StockWarehouseLocation;
  users?: Users;
}

export class StockPicking implements StockPickingInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "date_provided_invoice": Date;
  "weight": number;
  "weight_net": number;
  "gallery_id": number;
  "state": string;
  "supplier_picking": string;
  "order_supplier_ref": string;
  "related_claim_counter": number;
  "related_images_counter": number;
  "real_date": Date;
  "req_charge_date": Date;
  "note": string;
  "quality_state": string;
  "operator_id": number;
  "di_delivered": boolean;
  "quality_control": boolean;
  "partner_id": number;
  "product_move": number;
  "company_id": number;
  "move_lines": Array<any>;
  "location_id": number;
  "warehouse_location_id": number;
  partner: Partner;
  product: Product;
  company: Company;
  lines: StockMove[];
  location: StockLocation;
  warehouse_location: StockWarehouseLocation;
  users: Users;
  constructor(data?: StockPickingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StockPicking`.
   */
  public static getModelName() {
    return "StockPicking";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StockPicking for dynamic purposes.
  **/
  public static factory(data: StockPickingInterface): StockPicking{
    return new StockPicking(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StockPicking',
      plural: 'StockPickings',
      path: 'StockPickings',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "date_provided_invoice": {
          name: 'date_provided_invoice',
          type: 'Date'
        },
        "weight": {
          name: 'weight',
          type: 'number'
        },
        "weight_net": {
          name: 'weight_net',
          type: 'number'
        },
        "gallery_id": {
          name: 'gallery_id',
          type: 'number'
        },
        "state": {
          name: 'state',
          type: 'string'
        },
        "supplier_picking": {
          name: 'supplier_picking',
          type: 'string'
        },
        "order_supplier_ref": {
          name: 'order_supplier_ref',
          type: 'string'
        },
        "related_claim_counter": {
          name: 'related_claim_counter',
          type: 'number'
        },
        "related_images_counter": {
          name: 'related_images_counter',
          type: 'number'
        },
        "real_date": {
          name: 'real_date',
          type: 'Date'
        },
        "req_charge_date": {
          name: 'req_charge_date',
          type: 'Date'
        },
        "note": {
          name: 'note',
          type: 'string'
        },
        "quality_state": {
          name: 'quality_state',
          type: 'string',
          default: 'ok'
        },
        "operator_id": {
          name: 'operator_id',
          type: 'number'
        },
        "di_delivered": {
          name: 'di_delivered',
          type: 'boolean'
        },
        "quality_control": {
          name: 'quality_control',
          type: 'boolean'
        },
        "partner_id": {
          name: 'partner_id',
          type: 'number'
        },
        "product_move": {
          name: 'product_move',
          type: 'number'
        },
        "company_id": {
          name: 'company_id',
          type: 'number'
        },
        "move_lines": {
          name: 'move_lines',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "location_id": {
          name: 'location_id',
          type: 'number'
        },
        "warehouse_location_id": {
          name: 'warehouse_location_id',
          type: 'number'
        },
      },
      relations: {
        partner: {
          name: 'partner',
          type: 'Partner',
          model: 'Partner',
          relationType: 'belongsTo',
                  keyFrom: 'partner_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_move',
          keyTo: 'id'
        },
        company: {
          name: 'company',
          type: 'Company',
          model: 'Company',
          relationType: 'belongsTo',
                  keyFrom: 'company_id',
          keyTo: 'id'
        },
        lines: {
          name: 'lines',
          type: 'StockMove[]',
          model: 'StockMove',
          relationType: 'referencesMany',
                  keyFrom: 'move_lines',
          keyTo: 'id'
        },
        location: {
          name: 'location',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'location_id',
          keyTo: 'id'
        },
        warehouse_location: {
          name: 'warehouse_location',
          type: 'StockWarehouseLocation',
          model: 'StockWarehouseLocation',
          relationType: 'belongsTo',
                  keyFrom: 'warehouse_location_id',
          keyTo: 'id'
        },
        users: {
          name: 'users',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'operator_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/StockPicking.ts